import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { Tab } from '@optimus-web/core';
import { addressSection, FieldData, getGeneralSection, getGuestVerificationSection } from '../sections';
import { TabItemValue } from './enums';

interface TabItem {
    value: TabItemValue;
    textKey: Mews.TextKey;
    section: FieldData[];
}

interface GetTabsOptions {
    guestVerificationPhotoEnabled: boolean;
    areExtendedHotelConfiguredFieldsEnabled: boolean;
    isIdentityDocumentScanEnabled: boolean;
    isIdentityDocumentScanVerificationEnabled: boolean;
}

export const getTabs = ({
    guestVerificationPhotoEnabled,
    areExtendedHotelConfiguredFieldsEnabled,
    isIdentityDocumentScanEnabled,
    isIdentityDocumentScanVerificationEnabled,
}: GetTabsOptions): TabItem[] => [
    {
        textKey: TextKey.CheckInFieldsGeneralSection,
        value: TabItemValue.General,
        section: getGeneralSection(areExtendedHotelConfiguredFieldsEnabled),
    },
    { textKey: TextKey.Address, value: TabItemValue.Address, section: addressSection },
    { textKey: TextKey.CheckInFieldsDocumentPluralSection, value: TabItemValue.Documents, section: [] },
    {
        textKey: TextKey.CheckInFieldsGuestVerification,
        value: TabItemValue.GuestVerification,
        section: getGuestVerificationSection({
            guestVerificationPhotoEnabled,
            isIdentityDocumentScanEnabled,
            isIdentityDocumentScanVerificationEnabled,
        }),
    },
];

interface TabsProps {
    guestVerificationPhotoEnabled: boolean;
    areExtendedHotelConfiguredFieldsEnabled: boolean;
    isIdentityDocumentScanEnabled: boolean;
    isIdentityDocumentScanVerificationEnabled: boolean;
}

export const getTabsComponent = ({
    guestVerificationPhotoEnabled,
    areExtendedHotelConfiguredFieldsEnabled,
    isIdentityDocumentScanEnabled,
    isIdentityDocumentScanVerificationEnabled,
}: TabsProps) => {
    const tabs = getTabs({
        guestVerificationPhotoEnabled,
        areExtendedHotelConfiguredFieldsEnabled,
        isIdentityDocumentScanEnabled,
        isIdentityDocumentScanVerificationEnabled,
    });
    const filteredTabs =
        guestVerificationPhotoEnabled || isIdentityDocumentScanEnabled || isIdentityDocumentScanVerificationEnabled
            ? tabs
            : tabs.filter(({ value }) => value !== TabItemValue.GuestVerification);

    return filteredTabs.map(({ value, textKey }) => (
        <Tab id={value} key={value} value={value} label={<LocalizedText textKey={textKey} />} />
    ));
};
